import React, { useState, useEffect } from 'react';
import { globals } from '../globals';
import './SliderShow.css';

export default function SliderShow({ interval = 3000 }) {
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch(`${globals.homepageUrl}/php/get-sld-images.php`);
        const data = await res.json();
        if (data.success) setImages(data.images || []);
      } catch (err) {
        console.error('Errore nel recupero delle immagini:', err);
      }
    };
    fetchImages();
  }, []);

  useEffect(() => {
    if (images.length === 0) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images, interval]);

  if (images.length === 0) return null;

  return (
    <div className="slider-show">
      <div
        className="slider-track"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((img, index) => (
          <div className="slider-item" key={index}>
            <img
              src={`${globals.homepageUrl}/gallery/${img.folder}/large/${img.filename}`}
              alt=""
            />
          </div>
        ))}
      </div>
    </div>
  );
}
